import PlainGenderSelect from './PlainGenderSelect';

export default PlainGenderSelect;
